import { render, staticRenderFns } from "./TruckScanner.vue?vue&type=template&id=b6190ce6&scoped=true&"
import script from "./TruckScanner.vue?vue&type=script&lang=js&"
export * from "./TruckScanner.vue?vue&type=script&lang=js&"
import style0 from "./TruckScanner.vue?vue&type=style&index=0&id=b6190ce6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6190ce6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFlex,VTextField})
